module.exports = __webpack_public_path__ + "assets/img/3779b13bb67fa2e7a227041d5f1fb89f.png";